import type {SofieConfig} from '../modules/sofie/module';
// @ts-ignore
import config from '#sofie-config';

export function useSofieConfig() {
  return {
    ...config as Required<SofieConfig>,
    requiredVersion: '10.3, 11',
  };
}
